import { productService } from '../../helpers/services/product.service'
import { sharedHelper, filtersHelper } from '@/utils'

export const state = {
  list: { data: [], pagination: { pageNumber: 0, pageSize: 0, lastPage: 0, tableRowsCount: 0 } },
  details: {},
  status: { list: true, detail: true, save: true },
}

export const PRODUCT_MODULE = 'product'

export const GET_ALL_PRODUCTS = 'getAllProducts'
export const GET_PRODUCT = 'getProduct'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const LIST_SUCCESS = 'listSuccess'
const DETAIL_SUCCESS = 'detailSuccess'

function mapRow(item) {
  return {
    itemCode: item.item_code,
    description: item.description,
    desc2: item.desc2,
    itemGroup: item.item_group,
    itemType: item.item_type,
    itemBrand: item.item_brand,
    itemClass: item.item_class,
    itemCategory: item.item_category,
    baseUom: item.base_uom,
    salesUom: item.sales_uom,
    taxCode: item.tax_code,
    isActive: item.is_active,
    showInApp: item.show_in_app === undefined ? true : !!item.show_in_app,
    discontinued: item.discontinued,
    isSalesItem: item.is_sales_item,
    note: item.note,
    price: item.price,
    source: item.source || 'accounting',
    syncedAt: item.synced_at || null,
    prices: item.prices || [],
    stockBalances: item.stock_balances || [],
    createdAt: filtersHelper.getDateFormat(item.created_at),
    updatedAt: filtersHelper.getDateFormat(item.updated_at),
  }
}

export const actions = {
  [GET_ALL_PRODUCTS]({ commit }, { filter }) {
    commit(REQUESTING, 'list')
    productService.getAllProducts(filter).then((r) => {
      commit(LIST_SUCCESS, r); commit(SUCCESS)
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [GET_PRODUCT]({ commit }, { itemCode }) {
    commit(REQUESTING, 'detail')
    return productService.getProduct(itemCode).then((r) => {
      commit(DETAIL_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
}

export const mutations = {
  [LIST_SUCCESS](state, data) {
    const items = data.data || []
    state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)
    state.list.data = data.success ? items.map(mapRow) : items
  },
  [DETAIL_SUCCESS](state, data) {
    state.details = data.data ? mapRow(data.data) : {}
  },
  [FAILURE](state) { state.status = { list: true, detail: true, save: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true, detail: true, save: true } },
}
